import { DashboardLoadItemStatus, dateAndDowShort, shortGuid, StatusedTodo } from "@fusion-advantage/formlib"
import { V2L2DashboardListItem, V2L2DashboardListItemProps } from "./V2L2DashboardListItem"
import { FusionColor } from "../../../../theme/FusionStyle"
import { DateTime } from "luxon"

interface V2L2TodoListItemProps {
	statusedItem: StatusedTodo
	active: boolean
	onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L2TodoListItem = ({statusedItem, active, onClick}: V2L2TodoListItemProps) => {
	let props: V2L2DashboardListItemProps = {
		status: statusedItem.status,
		active,
		activeColor: FusionColor.OrangeMain,
		title: 'Error',
		onClick,
	}
	if(statusedItem.status === DashboardLoadItemStatus.Error) {
		props.id = `[${shortGuid(statusedItem.itemKey.encounterGuid)}⋯]`
	} else {
		const { item } = statusedItem
		props.title = item.MemberName
		if(item.CreatedOn) {
			props.id = dateAndDowShort(DateTime.fromISO(item.CreatedOn))
		}
	}
	return (
		<V2L2DashboardListItem {...props} />
	)
}
